module.exports = __webpack_public_path__ + "static/media/networkingM.993574f2.jpg";